module.exports = __webpack_public_path__ + "static/Christian-3df68504aef5235361f6db3db243ff8a.jpg";